import {ThemeOptions} from "@mui/material/styles/createTheme";
import {CSSInterpolation} from "@mui/material";

function createElevation(shadow: string): CSSInterpolation {
	return {
		boxShadow: shadow,
	};
}

const elevations = {
	elevation1: createElevation(
		"0 0.1px 0.3px rgba(28, 28, 30, 0.1), 0 1px 2px rgba(28, 28, 30, 0.2)"
	),
	elevation2: createElevation(
		"0 0.3px 0.5px rgba(28, 28, 30, 0.1), 0 2px 4px rgba(28, 28, 30, 0.2)"
	),
	elevation3: createElevation(
		"0 0.4px 0.8px rgba(28, 28, 30, 0.1), 0 3px 6px rgba(28, 28, 30, 0.2)"
	),
	elevation4: createElevation(
		"0 0.5px 1px rgba(28, 28, 30, 0.1), 0 4px 8px rgba(28, 28, 30, 0.2)"
	),
	elevation6: createElevation(
		"0 0.8px 1.5px rgba(28, 28, 30, 0.1), 0 6px 12px rgba(28, 28, 30, 0.2)"
	),
	elevation12: createElevation(
		"0 1.5px 3px rgba(28, 28, 30, 0.1), 0 12px 24px rgba(28, 28, 30, 0.2)"
	),
	elevation16: createElevation(
		"0 2px 4px rgba(28, 28, 30, 0.1), 0 16px 32px rgba(28, 28, 30, 0.2)"
	),
	elevation24: createElevation(
		"0 3px 6px rgba(28, 28, 30, 0.1), 0 24px 48px rgba(28, 28, 30, 0.2)"
	),
};

export const elevationTheme: ThemeOptions = {
	components: {
		MuiPaper: {
			styleOverrides: {
				...elevations,
			},
		},
	},
};
